import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {B2iRegistrationComponent} from './b2i-registration.component';
import {
  ComboBoxDropdownModule,
  ComboBoxModule,
  CountrySelectorModule,
  InputModule,
  TooltipModule
} from 'ng-design-system';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AuthGuard, ConfigModule, I18nModule} from '@spartacus/core';
import {UserRegistrationDoneGuard} from '@app/checkout/guards/user-registration-done.guard';
import {CustomerNameModule} from '../customer-name/customer-name.module';
import {ValidUserNameGuard} from '@app/shared/registration/valid-user-name.guard';
import {CcRestrictedCountryGuard} from '@app/checkout/guards/cc-restricted-country.guard';

@NgModule({
  declarations: [
    B2iRegistrationComponent
  ],
  imports: [
    CommonModule,
    InputModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    ComboBoxModule,
    ComboBoxDropdownModule,
    TooltipModule,
    CountrySelectorModule,
    CustomerNameModule,
    ConfigModule.withConfig({
      cmsComponents: {
        B2iRegistrationComponent: {
          component: B2iRegistrationComponent,
          guards: [
            AuthGuard,
            UserRegistrationDoneGuard,
            CcRestrictedCountryGuard,
            ValidUserNameGuard
          ],
        },
      }
    }),
  ],
  exports: [
    B2iRegistrationComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class B2iRegistrationModule {
}
